
const CommonActionType = {
    RESET_STATE: 'RESET_STATE',
    SET_PLATFORM_TYPE: 'SET_PLATFORM_TYPE'
}

export default CommonActionType